import { useMutation, useQueryClient } from "@tanstack/react-query";
import createArticleDetails from "../api/createArticleDetails";
import { Article, CreateArticleDetailsParams } from "../types";
import { articleGroupListQueryKey } from "./useArticleGroupListQuery";

export const useCreateArticleMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: CreateArticleDetailsParams) =>
      createArticleDetails(params),
    onMutate: async (params) => {
      await queryClient.cancelQueries({
        queryKey: articleGroupListQueryKey({
          brandId: params.brandId,
          categoryId: params.categoryId,
          groupId: params.groupId,
        }),
      });

      const previousArticles = queryClient.getQueryData(
        articleGroupListQueryKey({
          brandId: params.brandId,
          categoryId: params.categoryId,
          groupId: params.groupId,
        }),
      );

      queryClient.setQueryData(
        articleGroupListQueryKey({
          brandId: params.brandId,
          categoryId: params.categoryId,
          groupId: params.groupId,
        }),
        (old: Article[]) => [...old, { ...params.article, id: "temp-id" }],
      );

      return { previousArticles };
    },
    onError: (_, params, context) => {
      queryClient.setQueryData(
        articleGroupListQueryKey({
          brandId: params.brandId,
          categoryId: params.categoryId,
          groupId: params.groupId,
        }),
        context?.previousArticles,
      );
    },
    onSuccess: (data, variables) => {
      queryClient.setQueryData(
        articleGroupListQueryKey({
          brandId: variables.brandId,
          categoryId: variables.categoryId,
          groupId: variables.groupId,
        }),
        (old: Article[]) =>
          old.map((article: any) =>
            article.id === "temp-id" ? { ...article, id: data.id } : article,
          ),
      );
    },
  });
};
